<template>
    <section class="service-down flow">
        <h2 class="service-down__title">
            {{ myResources.title }}
        </h2>
        <p class="service-down__description">
            {{ myResources.description }}
        </p>
        <p class="service-down__service-message" v-if="hasServicingScheme" v-html="serviceText" />
    </section>
</template>

<script>

import ResourcesHelper from '@/components/resources-helper'
import InstanceTypeHelper from '@/components/instance-type-helper'
import strings from '@/helpers/strings'

export default {
    mixins: [
        InstanceTypeHelper,
        ResourcesHelper,
    ],

    props: {
        contactEmail: {
            type: String,
            default: '',
        },
    },

    computed: {
        /**
         * Return the resources object for this page.
         * @return {AppCoreServiceDownResources}
         */
        myResources() {
            return this.parseResources('components.appCore.serviceDown')
        },

        serviceText() {
            return strings.parse(this.myResources.serviceText, {
                contactEmail: `<a href="mailto:${ this.contactEmail }">${ this.contactEmail }</a>`,
            })
        },

        /**
         * @return {boolean}
         */
        hasServicingScheme() {
            return this.servicingScheme !== null && this.contactEmail !== ''
        },
    },
}

</script>
